import { useEffect } from 'react';
import type {
  CompanyWorkspace,
  WorkspaceContract,
} from '@nest-react/domain';
import type { AppLocale } from '@nest-react/lib';

import { useWorkspaceStore } from './workspaceStore';

export const useWorkspaceIdentitySync = ({
  activeWorkspaceId,
  workspaceContracts,
  companies,
  locale,
}: {
  activeWorkspaceId: string | null;
  workspaceContracts: WorkspaceContract[];
  companies: CompanyWorkspace[];
  locale: AppLocale;
}): void => {
  const setWorkspaceIdentity = useWorkspaceStore(
    state => state.setWorkspaceIdentity
  );

  useEffect(() => {
    setWorkspaceIdentity({
      activeWorkspaceId,
      workspaceContracts,
      companies,
      locale,
    });
  }, [
    activeWorkspaceId,
    companies,
    locale,
    setWorkspaceIdentity,
    workspaceContracts,
  ]);
};
